module.exports = __webpack_public_path__ + "img/ticket.f92de3f1.svg";